"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triangle = void 0;
const gl_matrix_1 = require("gl-matrix");
class Triangle {
    constructor(_v0 = gl_matrix_1.vec3.create(), _v1 = gl_matrix_1.vec3.create(), _v2 = gl_matrix_1.vec3.create()) {
        this._v0 = _v0;
        this._v1 = _v1;
        this._v2 = _v2;
    }
    applyMatrix(matrix) {
        gl_matrix_1.vec3.transformMat4(this._v0, this._v0, matrix);
        gl_matrix_1.vec3.transformMat4(this._v1, this._v1, matrix);
        gl_matrix_1.vec3.transformMat4(this._v2, this._v2, matrix);
        return this;
    }
    clone() {
        return new Triangle(gl_matrix_1.vec3.clone(this._v0), gl_matrix_1.vec3.clone(this._v1), gl_matrix_1.vec3.clone(this._v2));
    }
    // Möller–Trumbore intersection algorithm
    intersect(origin, direction) {
        const EPSILON = 0.0000001;
        const edge1 = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), this._v1, this._v0);
        const edge2 = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), this._v2, this._v0);
        const h = gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), direction, edge2);
        const a = gl_matrix_1.vec3.dot(edge1, h);
        if (a > -EPSILON && a < EPSILON)
            return null; // This ray is parallel to this triangle.
        const f = 1.0 / a;
        const s = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), origin, this._v0);
        const u = f * gl_matrix_1.vec3.dot(s, h);
        if (u < 0.0 || u > 1.0)
            return null;
        const q = gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), s, edge1);
        const v = f * gl_matrix_1.vec3.dot(direction, q);
        if (v < 0.0 || u + v > 1.0)
            return null;
        // At this stage we can compute t to find out where the intersection point is on the line.
        const t = f * gl_matrix_1.vec3.dot(edge2, q);
        return t > EPSILON ? gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), direction, gl_matrix_1.vec3.fromValues(t, t, t)), origin) : null;
    }
    reset() {
        this._v0 = gl_matrix_1.vec3.create();
        this._v1 = gl_matrix_1.vec3.create();
        this._v2 = gl_matrix_1.vec3.create();
    }
}
exports.Triangle = Triangle;
//# sourceMappingURL=Triangle.js.map